<ng-container>
    <mat-icon (click)="prev()">chevron_left</mat-icon>
    <span class="st-pager-label">{{ label }}</span>
    <mat-icon (click)="next()">chevron_right</mat-icon>
</ng-container>
